import $ from "jquery";
import _ from "lodash";
import "./accordion";
import {
  awaitSelector,
  watchAwaitSelector,
  addAttribute,
  delAttribute,
  ariaLabelFromInnerHTML,
  wrap,
  wait,
  setUpClickAndEnterKey,
  restoreFocus,
  trapFocus,
  replaceElement,
} from "./functions";

// Document load/ready promise, calls run function when done
HTMLDocument.prototype.ready = function () {
  return new Promise(function (resolve, reject) {
    if (document.readyState === "complete") {
      resolve(document);
    } else {
      document.addEventListener("DOMContentLoaded", function () {
        resolve(document);
      });
    }
  });
};

// Custom global scripts
jQuery(document).ready(function ($) {
  "use strict";

  // Add Foundation modal reveal trigger
  // document.getElementById('location_honey_cafe_menu').style.display = "none";

  if (
    window.innerWidth > 768 &&
    document.querySelector('a[data-fancybox-trigger="gallery-honey-cafe"]')
  ) {
    addAttribute(
      'a[data-fancybox-trigger="gallery-honey-cafe"]',
      "data-open",
      "location_honey_cafe_menu"
    );
    addAttribute(
      'a[data-fancybox-trigger="gallery-honey-cafe"]',
      "aria-controls",
      "location_honey_cafe_menu"
    );
    addAttribute(
      'a[data-fancybox-trigger="gallery-honey-cafe"]',
      "aria-haspopup",
      "true"
    );
    addAttribute(
      'a[data-fancybox-trigger="gallery-honey-cafe"]',
      "data-reveal-id",
      "location_honey_cafe_menu"
    );
    addAttribute("#main", "tabindex", "-1");

    // Remove old Fancybox gallery trigger
    delAttribute('a[data-fancybox-trigger="gallery-honey-cafe"]', "href");
    delAttribute(
      'a[data-fancybox-trigger="gallery-honey-cafe"]',
      "data-fancybox-trigger"
    );
  }

  $("table").keyup(function (e) {
    if (e.key === "ArrowRight") {
      if (e.target.tagName === "TH") {
        if (
          $(e.target).parent("tr").parent()[0].tagName === "THEAD" &&
          e.target !== $("table thead th:last-of-type")[0]
        ) {
          $(e.target).next("th").focus();
        } else if (e.target === $("table thead th:last-of-type")[0]) {
          $(
            $(e.target).closest("thead").next("tbody").find("tr th")[0]
          ).focus();
        } else {
          $(e.target).next("td").focus();
        }
      } else if (e.target.tagName === "TD") {
        if (
          e.target === $(e.target).closest("tr").find("td:last-of-type")[0] &&
          $(e.target).closest("tr")[0] !==
            $(e.target).closest("table").find("tbody tr:last-of-type")[0]
        ) {
          $($(e.target).closest("tr").next("tr").find("th")[0]).focus();
        } else if (
          e.target ===
          $(e.target)
            .closest("table")
            .find("tbody tr:last-of-type td:last-of-type")[0]
        ) {
          // If we're pressing RIGHT on the last item in the last row, send focus out of the table
          if ($(e.target).closest("section").find(".buttons-wrap").length > 0) {
            $(e.target)
              .closest("section")
              .find(".buttons-wrap a:first-of-type")
              .focus();
          } else {
            if ($(".container.notes-section a").length > 0) {
              $(".container.notes-section a").focus();
            } else {
              $(e.target)
                .closest("table")
                .parent(".packages-table-wrap")
                .parent()
                .parent()
                .find("*[tabindex]:not(table)")
                .focus();
            }
          }
        } else {
          $(e.target).next("td").focus();
        }
      }
    } else if (e.key === "ArrowLeft") {
      if (e.target.tagName === "TH") {
        if (
          $(e.target).parent("tr").parent()[0].tagName === "THEAD" &&
          e.target !== $("table thead th:first-of-type")[0]
        ) {
          $(e.target).prev("th").focus();
        } else if (e.target === $("table thead th:first-of-type")[0]) {
          $(e.target).closest("table").focus();
        } else if (
          e.target === $("table tbody tr:first-of-type th:first-of-type")[0]
        ) {
          $(
            $(e.target)
              .closest("tbody")
              .prev("thead")
              .find("tr th:last-of-type")[0]
          ).focus();
        } else if ($(e.target).parent("tr").parent()[0].tagName === "TBODY") {
          $(e.target).closest("tr").prev("tr").find("td:last-of-type").focus();
        } else {
          $(e.target).prev("td").focus();
        }
      } else if (e.target.tagName === "TD") {
        if (
          e.target === $(e.target).closest("tr").find("td:first-of-type")[0]
        ) {
          $(e.target).prev("th").focus();
        } else {
          $(e.target).prev("td").focus();
        }
      }
    } else if (e.key === "ArrowDown") {
      if (
        $(e.target).parent("tr")[0] ===
        $(e.target).closest("table").find("tbody").find("tr:last-of-type")[0]
      ) {
        // If we're pressing DOWN anywhere in the last row, send focus out of the table
        if ($(e.target).closest("section").find(".buttons-wrap").length > 0) {
          $(e.target)
            .closest("section")
            .find(".buttons-wrap a:first-of-type")
            .focus();
        } else {
          if ($(".container.notes-section a").length > 0) {
            $(".container.notes-section a").focus();
          } else {
            $(e.target)
              .closest("table")
              .parent(".packages-table-wrap")
              .parent()
              .parent()
              .find("*[tabindex]:not(table)")
              .focus();
          }
        }
      } else if ($(e.target).parent("tr").parent()[0].tagName === "THEAD") {
        // Pressing DOWN while in the THEAD, focus into TBODY
        var child = e.target;
        var i = 0;
        while ((child = child.previousSibling) != null) i++;
        $(
          $(e.target)
            .closest("tr")
            .parent()
            .next("tbody")
            .find("tr:first-of-type")[0].childNodes[i]
        ).focus();
      } else {
        // Pressing DOWN while inside the TBODY and NOT on last-row
        var child = e.target;
        var i = 0;
        while ((child = child.previousSibling) != null) i++;
        $($(e.target).parent("tr").next("tr")[0].childNodes[i]).focus();
      }
    } else if (e.key === "ArrowUp") {
      if ($(e.target).parent("tr").parent()[0].tagName === "THEAD") {
        // If we're pressing UP anywhere in the first row, send focus up to TABLE
        $(e.target).closest("table").focus();
      } else if (
        $(e.target).parent("tr")[0] ===
        $(e.target).closest("table").find("tbody").find("tr:first-of-type")[0]
      ) {
        // Pressing UP while in first row of table, transfer up to same relative TH
        var child = e.target;
        var i = 0;
        while ((child = child.previousSibling) != null) i++;
        $(
          $(e.target).parent("tr").parent("tbody").prev("thead").find("tr")[0]
            .childNodes[i]
        ).focus();
      } else {
        // Pressing UP anywhere else in the table
        var child = e.target;
        var i = 0;
        while ((child = child.previousSibling) != null) i++;
        $($(e.target).parent("tr").prev("tr")[0].childNodes[i]).focus();
      }
    }
  });

  // Foundation Init
  $(document).foundation({
    equalizer: {
      equalize_on_stack: true,
    },
  });

  // Opened is emitted when the modal has been fully loaded/revealed
  $(document).on("opened.fndtn.reveal", "[data-reveal]", function () {
    if (document.querySelector("#location_honey_cafe_menu > h2")) {
      document.querySelector("#location_honey_cafe_menu > h2").focus();
    }
  });

  // Emit close event when close button is clicked
  $("button[data-close]").on("click", function () {
    $(document).foundation("reveal", "close");
  });

  // Promotional modals should display only once for each visitor...
  $(".reveal-modal--promo").each(function (index, el) {
    const hasDisplayed = localStorage.getItem(el.id);
    if (!hasDisplayed) {
      $(`#${el.id}`).foundation("reveal", "open");
      
      // ADA - set aria-hidden="true" to sibling content until closed
      const items = document.querySelectorAll('body > *:not(.reveal-modal--promo)');
      console.log("items are", items);
      for(const item of items) {
        item.setAttribute('aria-hidden', 'true');
      }
    }
  });

  // ...then mark promo modal as displayed once it has displayed and closed
  $(document).on("close.fndtn.reveal", "[data-reveal]", function () {
    localStorage.setItem(this.id, Date.now());
    
    // ADA - remove aria-hidden="true" from sibling content
      const items = document.querySelectorAll('body > *:not(.reveal-modal--promo)');
      for(const item of items) {
        item.setAttribute('aria-hidden', 'false');
      }
  });

  // Fancybox gallery init
  $(".fancybox").fancybox({
    autoFocus: true,
    backFocus: true,
    trapFocus: true,
    keyboard: true,
    smallBtn: true,
    buttons: ["close"],
    afterShow: function (instance, current) {
      $(".fancybox-image").attr("tabindex", "-1");
      $(".fancybox-slide--current .fancybox-image").attr("tabindex", "0");
      $(".fancybox-slide--current .fancybox-image").focus();
      if ($(".fancybox-caption")[0].innerText.length > 0) {
        $(".fancybox-slide--current .fancybox-image").attr(
          "alt",
          $(".fancybox-caption")[0].innerText
        );
      }
    },
  });

  // Mobile nav toggle
  if (document.querySelector("#nav-mobile-toggle")) {
    document
      .querySelector("#nav-mobile-toggle")
      .addEventListener("click", function (e) {
        $("#nav-mobile").slideToggle();
        $("#nav-mobile").find(".is-open").slideUp().removeClass("is-open");
      });
  }

  $(document).on("click", ":not(#nav-mobile)", function (event) {
    if (
      event.srcElement.id !== "nav-mobile-toggle" &&
      !event.srcElement.classList.contains("j-slide-toggle")
    ) {
      $("#nav-mobile").slideUp();
      $("#nav-mobile").find(".is-open").slideUp().removeClass("is-open");
    }
  });

  $(".j-slide-toggle").on("click", function (event) {
    event.preventDefault();

    const $parent = $(this).parent(); // li.has-submenu
    const $submenu = $parent.find(".submenu");
    if ($submenu.hasClass("is-open")) {
      $submenu.slideUp().removeClass("is-open");
    } else {
      $submenu.slideDown().addClass("is-open");
    }
  });

  // Interior mobile nav toggle
  $(".interior-nav-mobile-toggle").on("click", function () {
    var $this = $(this);
    $this.closest(".interior-nav-wrap").find(".interior-nav").slideToggle();
  });

  // Close menu after click
  $(".interior-nav li:not(.has-submenu) a").on("click", function (event) {
    $(this).closest(".interior-nav").slideUp();
  });

  $('a[href="#"]').on("click", (e) => {
    e.preventDefault();
  });

  // Smooth Scroll to Anchor
  $('a[href^="#"]')
    .not("a[data-fancybox-trigger]")
    .on("click", function (e) {
      var $this = $(this),
        target = $($this.attr("href")),
        header;
      if (document.querySelector(".location-nav")) {
        header = 0;
      } else if (document.querySelector(".interior-nav-wrap--sticky")) {
        header = document
          .querySelector(".interior-nav-wrap--sticky")
          .getBoundingClientRect().height;
      } else if (document.querySelector(".site-header--sticky")) {
        header = document
          .querySelector(".site-header--sticky")
          .getBoundingClientRect().height;
      } else {
        header = this.closest(".j-site-nav").getBoundingClientRect().height;
      }

      if (target.length) {
        console.log(target[0]);
        e.preventDefault();

        let scrollTop = target.offset().top - header;
        if (target.find(".j-scrollto-override").length) {
          scrollTop = target.find(".j-scrollto-override").offset().top - header;
        }

        $("html, body").animate(
          {
            scrollTop: scrollTop,
          },
          1000
        );

        setTimeout(function () {
          target[0].focus();
        }, 1000);
      }
    });

  // Fix .features-grid overlay not triggering on :hover on ios devices
  const isMobile = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
      return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
      return (
        isMobile.Android() ||
        isMobile.BlackBerry() ||
        isMobile.iOS() ||
        isMobile.Opera() ||
        isMobile.Windows()
      );
    },
  };

  if (isMobile.iOS()) {
    $(".features-grid > li").on("click", function (event) {
      $(this).trigger("hover");
    });
  }

  function stickyNav(
    header = "site-header",
    placeholder = "site-header-placeholder"
  ) {
    const headerItem = document.querySelector(`.${header}`),
      placeholderItem = document.querySelector(`.${placeholder}`),
      headerClass = header,
      placeholderClass = placeholder,
      height = headerItem.getBoundingClientRect().height,
      top = headerItem.offsetTop;

    // let top;
    function headerMeasure() {
      // let refOffset = 0;
      setTimeout(() => {
        let $window = Math.round(window.pageYOffset);
        if ($window > top) {
          headerItem.classList.add(`${headerClass}--sticky`);
          headerItem.classList.add(`${headerClass}--animateIn`);
          headerItem.classList.remove(`${headerClass}--animateOut`);
          placeholderItem.style.height = `${height}px`;
        } else {
          headerItem.classList.remove(`${headerClass}--sticky`);
          headerItem.classList.add(`${headerClass}--animateOut`);
          headerItem.classList.remove(`${headerClass}--animateIn`);
          placeholderItem.style.height = "0px";
        }
      }, 10);
    }
    window.addEventListener("scroll", headerMeasure);
  }
  $(document).ready(() => {
    let navTime;
    if (document.querySelector(".interior-nav-wrap")) {
      navTime = stickyNav("interior-nav-wrap", "interior-nav-placeholder");
      window.addEventListener("scroll", navTime);
      stickyNav("interior-nav-wrap", "interior-nav-placeholder");
    } else {
      navTime = stickyNav();
      window.addEventListener("scroll", navTime);
      stickyNav();
    }
  });

  // Video Playback
  $(".video-play").on("click", function (e) {
    e.preventDefault();
    var $this = $(this),
      id = $this.data("target"),
      $bg = $this.closest(".banner"),
      $content = $bg.find("#banner-video-text"),
      $el = $(id);
    // Instead of removing the elements with display:none
    // assign the visuallyhidden class which makes them
    // "invisible" but remain accessible to screen readers
    $content.addClass("visuallyhidden");
    $this.addClass("visuallyhidden");
    $("#video-controls").show();
    $bg.css("background", "#000");
    $el.fadeIn(1000);
    $el[0].play();
  });

  document.querySelector(".skip-main").addEventListener("click", function () {
    document.querySelector("#main").focus();
  });

  $(".buzz-slides, .buzz-nav").on(
    "init beforeChange afterChange reInit",
    function () {
      setTimeout(function () {
        const slides = document.querySelectorAll(
          ".slick-slide[aria-describedby]"
        );
        $(slides).removeAttr("aria-describedby");
      }, 750);
      const $buzzListBox = $('.buzz-slides .slick-track[role="listbox"]');
      if ($buzzListBox.length > 0) {
        $buzzListBox.removeAttr("role");
      }
      const $slickSlides = $(".slick-slide");
      if ($slickSlides.length > 0) {
        $slickSlides.removeAttr("role");
      }
      const $buzzNavBox = $('.buzz-nav slick-track[role="listbox"]');
      if ($buzzNavBox.length > 0) {
        $buzzNavBox.removeAttr("role");
      }
    }
  );

  document.addEventListener("keydown", function (e) {
    // If Enter key is pressed, and if the current focused element has the 'slick-slide' class
    if (
      e.keyCode === 13 &&
      document.activeElement.classList.contains("slick-slide")
    ) {
      // Click the focused element
      $(document.activeElement)
        .closest(".slick-slider")
        .slick(
          "slickGoTo",
          document.activeElement.getAttribute("data-slick-index")
        );
    }

    // If Enter key is pressed, and if the current focused element has the 'button' class
    if (
      e.keyCode === 13 &&
      document.activeElement.classList.contains("button")
    ) {
      // Click the focused element
      document.activeElement.click();
    }

    // If tab is pressed when close-button is active, and shift key is not down
    if (
      !escape.shiftKey &&
      e.keyCode === 9 &&
      document.activeElement.classList.contains("close-button")
    ) {
      // Close button is last element that can be focused, so loop back to start of modal
      document.querySelector("#location_honey_cafe_menu").focus();
    }

    // If shift+tab is pressed with the modal active (default would be to tab to elements outside of the modal)
    if (
      e.shiftKey &&
      e.keyCode == 9 &&
      document.activeElement ===
        document.getElementById("location_honey_cafe_menu")
    ) {
      e.preventDefault();
      //shift was down when tab was pressed
      document.querySelector("#location_honey_cafe_menu .close-button").focus();
    }
  });

  // Focus active slide
  $(".buzz-slides").on("afterChange", function (e) {
    // Mark all as unchecked
    addAttribute(".buzz-nav .slick-slide", "aria-selected", "false");
    // // Make sure the active slide can be focused
    document
      .querySelector(".buzz-nav .slick-current")
      .setAttribute("tabindex", "0");
    // // Focus the active slide
    document.querySelector(".buzz-nav .slick-current").focus();
    document
      .querySelector(".buzz-nav .slick-current")
      .setAttribute("aria-selected", true);
  });

  // // Buzz Slider
  $(".buzz-slides").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    accessibility: true,
    asNavFor: ".buzz-nav",
    infinite: true,
    //focusOnSelect: true
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: false,
        },
      },
    ],
  });
  //
  $(".buzz-nav").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: ".buzz-slides",
    dots: false,
    arrows: true,
    nextArrow:
      '<button class="slick-next slick-arrow" aria-label="Next" style="display: block;">Next</button>',
    prevArrow:
      '<button class="slick-prev slick-arrow" aria-label="Previous" style="display: block;">Previous</button>',
    //focusOnSelect: true,
    //accessibility: true
  });

  $(".buzz-nav .slick-slide").on("click", function (e) {
    $(this)
      .closest(".slick-slider")
      .slick("slickGoTo", $(this).attr("data-slick-index"));
  });

  // Adds Included/Not Included text to cells with/without checkmarks,
  // and makes it visually hidden but still accessible to screen readers
  $('.packages-table td:contains("yes")').each(function () {
    var text = $(this).text();
    if (text == "yes") {
      $(this).html('<span class="checked" aria-label="Included"></span>');
    }
  });

  $('.packages-table td:contains("no")').each(function () {
    var text = $(this).text();
    if (text == "no") {
      $(this).html('<span class="unchecked" aria-label="Not included"></span>');
    }
  });

  //   Add label to each cell for mobile
  $(".packages-table tbody tr").each(function () {
    var $this = $(this),
      label = $this.find("th:first-of-type").text();
    $this.find("td").prepend('<span class="label">' + label + "</span>");
  });

  // Hides the table labels to prevent "doubling" the screen reader text
  // since it was reading the cell contents and the label
  var $tableLabel = $("tbody .label");
  if (window.innerWidth >= 640) {
    $tableLabel.attr({
      "aria-hidden": true,
    });
  } else {
    $tableLabel.attr({
      "aria-hidden": false,
    });
  }

  $(".packages-table td .checked")
    .closest("td")
    .children(".checked")
    .text("Yes")
    .removeClass("checked");
  $(".packages-table td .unchecked")
    .closest("td")
    .children(".unchecked")
    .text("No")
    .removeClass("unchecked")
    .attr("aria-label", "Not Included")
    .css("opacity", "0");
  //$('.packages-table td .unchecked').closest('td').attr('aria-label', 'Not Included').text('');

  window.addEventListener("resize", function (e) {
    // Foundation medium-up
    if (window.innerWidth >= 640) {
      $tableLabel.attr({
        "aria-hidden": true,
      });
    } else {
      $tableLabel.attr({
        "aria-hidden": false,
      });
    }
  });

  const $mobileNav = $("#nav-mobile");
  if ($mobileNav.length > 0) {
    if (window.innerWidth > 1176) {
      $mobileNav.attr({
        "aria-hidden": true,
      });
    }
    window.addEventListener("resize", function (e) {
      if (window.innerWidth > 1176) {
        $mobileNav.attr({
          "aria-hidden": false,
        });
      }
    });
  }

  const $allHeaders = $("header");
  if ($allHeaders.length > 0) {
    $allHeaders.each(function () {
      if ($(this).attr("role") == "banner") {
        this.removeAttribute("role");
      }
    });
  }

  const $toggleContrast = $("button#toggle-contrast");
  if ($toggleContrast.length > 0) {
    $toggleContrast.click(function () {
      if (getCookie("contrast") == "") {
        document.body.classList.add("high-contrast");
        setCookie("contrast", "enabled", 1);
        checkCookie();
      } else {
        setCookie("contrast", "", 1);
        document.body.classList.remove("high-contrast");
        checkCookie();
      }
    });
  }

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function checkCookie() {
    var contrastMode = getCookie("contrast");
    if (contrastMode != "") {
      toggleContrast(false);
    } else {
      toggleContrast(true);
    }
  }

  function toggleContrast(toggle) {
    const toggleButtonText = document.querySelector("#toggle-contrast > span");
    if (toggleButtonText) {
      if (toggle === true) {
        document.querySelector("body").classList.add("high-contrast");
        toggleButtonText.innerText = "High Contrast: Enabled";
        $toggleContrast.attr("aria-pressed", true);
        // var allNodes = document.getElementsByTagName('*');
        var allNodes = document.querySelectorAll("*:not(.hc-ignore)");
        if (allNodes.length > 0) {
          var colorPairs = {
            "rgb(0, 167, 225)": "#00678A",
            "rgb(255, 76, 0)": "#A83200",
            "rgb(255, 182, 0)": "#0e38cc",
            "rgb(255, 145, 0)": "#0e38cf",
            "rgb(255, 155, 0)": "#0d0d33",
            "rgb(181, 198, 14)": "#636D09",
            "rgb(255, 205, 0)": "#8A6E00",
          };
          $(allNodes).each(function () {
            var that = this;
            for (var brightColor in colorPairs) {
              // if( !$(that).hasClass('hc-ignore') ) {
              if ($(that).css("color").toLowerCase() === brightColor) {
                $(that).css("color", colorPairs[brightColor]);
              }
              if (
                $(that).css("background-color").toLowerCase() === brightColor
              ) {
                $(that).css("background-color", colorPairs[brightColor]);
              }
              // }
            }
          });
        }
      } else {
        // var allNodes = document.getElementsByTagName('*');
        document.body.classList.remove("high-contrast");
        toggleButtonText.innerText = "High Contrast: Disabled";
        $toggleContrast.attr("aria-pressed", false);

        var allNodes = document.querySelectorAll("*:not(.hc-ignore)");
        if (allNodes.length > 0) {
          var colorPairs = {
            "rgb(0, 167, 225)": "rgb(0, 103, 138)",
            "rgb(255, 76, 0)": "rgb(168, 50, 0)",
            "rgb(255, 182, 0)": "rgb(14, 56, 204)",
            "rgb(255, 145, 0)": "rgb(14, 56, 207)",
            "rgb(255, 155, 0)": "rgb(13, 13, 51)",
            "rgb(181, 198, 14)": "rgb(99, 109, 9)",
            "rgb(255, 205, 0)": "rgb(138, 110, 0)",
          };
          $(allNodes).each(function () {
            var that = this;
            for (var brightColor in colorPairs) {
              // if( !$(that).hasClass('hc-ignore') ) {
              if (
                $(that).css("color").toLowerCase() === colorPairs[brightColor]
              ) {
                $(that).css("color", brightColor);
              }
              if (
                $(that).css("background-color").toLowerCase() ===
                colorPairs[brightColor]
              ) {
                $(that).css("background-color", brightColor);
              }
              // }
            }

            // if( 'xxx' == that.id ) {
            //     const bgCol = $(that).css('background-color');
            //     console.log( 'xxx: ' + bgCol + ', ' + colorPairs[bgCol] );
            // }
          });
        }
      }
    }
  }
  checkCookie();
  $(window).keyup(function (e) {
    if (e.key === "Tab") {
      if ($(".panel-grid").length > 0) {
        $(".panel-grid .panel-item").css("display", "table");
        $(".panel-grid .overlay").css("display", "block");
        $(".panel-grid .panel-item .inner").css("display", "table-cell");
        $(".panel-grid .panel-item .inner").css("vertical-align", "middle");
        $(".panel-grid .panel-item .panel-title").css("display", "none");
      }
      if ($(".features-grid").length > 0) {
        $(".features-grid .inner h2").css("display", "none");
        $(".features-grid .inner .overlay").css("display", "block");
      }
    }
  });
  const $nav = $("ul.nav-footer");
  if ($nav.length > 0) {
    var wifiMenuItem = document.createElement("li");
    wifiMenuItem.classList.add(
      "wifi",
      "menu-item",
      "menu-item-type-custom",
      "menu-item-object-custom",
      "menu-item-41"
    );
    $(wifiMenuItem).html(
      `<img src="/wp-content/themes/billy-beez/assets/images/free-wifi.png" alt="Free Wifi">`
    );
    $nav[0].appendChild(wifiMenuItem);
  }

  $(".wpcf7 .g-recaptcha").attr(
    "aria-label",
    "Verify that you are not a robot *"
  );

  function locationSelect(
    hook = "#menu-item-238 a",
    form = "[data-book-a-party]"
  ) {
    const headerBookParty = document.querySelector(hook);

    let headerLocationsForm = document.querySelector(form);
    if (headerLocationsForm && headerLocationsForm) {
      // Move headerLocationsForm into headerBookParty li
      headerLocationsForm = headerBookParty
        .closest("li")
        .appendChild(headerLocationsForm);
      const locationsSelect = headerLocationsForm.querySelector("select");

      headerBookParty.addEventListener("click", function (e) {
        e.preventDefault();

        $(headerLocationsForm).slideDown();

        headerLocationsForm.setAttribute("tabindex", "0");
        headerLocationsForm.focus();
      });

      headerLocationsForm.addEventListener("focusout", function (e) {
        if ($(form).find(e.relatedTarget).length === 0) {
          // $(headerLocationsForm).slideUp();
          headerLocationsForm.setAttribute("tabindex", "-1");
        }
      });

      locationsSelect.addEventListener("change", function (e) {
        if (locationsSelect.selectedIndex !== 0) {
          const locationTitle = e.target.selectedOptions[0].firstChild.data;
          headerLocationsForm
            .querySelector('input[type="submit"]')
            .setAttribute(
              "aria-label",
              `Go to the Party Booking page for ${locationTitle}`
            );
          headerLocationsForm
            .querySelector('input[type="submit"]')
            .removeAttribute("disabled", "false");
        } else {
          headerLocationsForm
            .querySelector('input[type="submit"]')
            .setAttribute("aria-label", `Select a location!`);
          headerLocationsForm
            .querySelector('input[type="submit"]')
            .setAttribute("disabled", `true`);
        }
      });

      headerLocationsForm.addEventListener("submit", function (e) {
        e.preventDefault();

        if (locationsSelect) {
          const selectedValue =
            locationsSelect[locationsSelect.selectedIndex].value;
          const regex = /^http.*:\/\/.*/gm;
          const str = `${selectedValue}`;
          let fullUrl = false;

          let m;
          while ((m = regex.exec(str)) !== null) {
            // This is necessary to avoid infinite loops with zero-width matches
            if (m.index === regex.lastIndex) {
              regex.lastIndex++;
            }

            // The result can be accessed through the `m`-variable.
            m.forEach((match, groupIndex) => {
              fullUrl = true;
            });
          }

          let buildUrl = ``;
          if (!fullUrl) {
            buildUrl = `${window.location.protocol}//${window.location.host}${selectedValue}`;
          } else {
            buildUrl = `${selectedValue}`;
          }
          window.location.replace(buildUrl);
        }
      });
    }
  }
  locationSelect();
  let locationTown = ["party", "group"];
  locationTown.forEach((element) => {
    if (document.querySelector(`[data-locations-form-${element}]`)) {
      locationSelect(
        `[data-locations-form-${element}]`,
        `[data-locations-${element}]`
      );
    }
  });

  if ($(".interior-nav").length > 0) {
    $(".has-submenu > a").click((e) => {
      e.preventDefault();
      $(".has-submenu").toggleClass("open-submenu");
    });
  }

  // Hide cookie bar
  $("#close-cookies").click((e) => {
    e.preventDefault();
    localStorage.setItem("setupTime", Date.now());
    $("#cookie-bar").hide();
  });

  if (localStorage.getItem("setupTime")) {
    $("#cookie-bar").hide();
  }

  // Clear localStorage if expired
  var lastclear = localStorage.getItem("setupTime"),
    time_now = new Date().getTime();

  // .getTime() returns milliseconds so 1000 * 60 * 60
  if (time_now - lastclear > 24 * 60 * 60 * 1000) {
    localStorage.clear();
  }
});

// Remove invalid role attributes on Contact Forms 7 errors
watchAwaitSelector(
  function (elements) {
    for (var error of elements) {
      error.removeAttribute("role");
    }
  },
  "[role='alert'].wpcf7-not-valid-tip",
  document,
  2500
);

// Called once page is fully loaded
if (window.innerWidth > 768) {
  document.ready().then(function () {
  

    addAttribute(
      ".buzz-nav .slick-track",
      "aria-label",
      "Slideshow of offers, news, and deals"
    );

    // Elements to add tabindex=0
    // Probably don't need everything with a tabindex, keeping just in case though
    var elementsToFocus = [".h193"];

    // Use the map() function method to loop through an array’s items
    elementsToFocus.map(function (val) {
      return addAttribute(val, "tabindex", "0");
    });

    var elementsToRemoveFocus = [
      ".admission-packs li",
      "p .wp-image-600",
      "#section-buzz > div > div.buzz-slides.slick-initialized.slick-slider > div > div > div",
      "#section-buzz > div > div.buzz-slides.slick-initialized.slick-slider > div > div > div > div > header > h2",
      ".slick-slide .inner h2",
      ".social-icons li",
      ".category h2.text-shadow",
      ".visuallyhidden",
      ".location-title h2",
      "#banner-video-text h1",
    ];
    // var elementsToRemoveFocus = ['.admission-packs li', 'p .wp-image-600', '.slick-slide .inner h2', '.social-icons li', '.category h2.text-shadow', '.visuallyhidden'];
    elementsToRemoveFocus.map(function (val) {
      return addAttribute(val, "tabindex", "-1");
    });

    // Somehow the paragraph tags in the WordPress editor for the page https://billybeezus.com/summer-family-4-packs/
    // are being replaced by h4 tags, which are not nested correctly (the only other header on the page is h1)
    // This replaces the h4 tags with h2 tags and reduces the font size to match the previous styling
    var h4 = document.querySelectorAll("h4");
    for (var i = 0; i < h4.length; i++) {
      if (
        h4[i].innerText ===
        "Swing into Summer with your family! Enjoy a Family 4 Pack for just $40!"
      ) {
        let h2 = document.createElement("h2");
        h2.innerText =
          "Swing into Summer with your family! Enjoy a Family 4 Pack for just $40!";
        h2.setAttribute(
          "style",
          "text-align:center;font-size:1.5rem;display:block;"
        );
        h4[i].parentNode.replaceChild(h2, h4[i]);
      } else if (
        h4[i].innerText ===
        "Available in the Crystal Run, Kingston and Walden locations. See store for details."
      ) {
        let h2 = document.createElement("h2");
        h2.innerText =
          "Available in the Crystal Run, Kingston and Walden locations. See store for details.";
        h2.setAttribute(
          "style",
          "text-align:center;font-size:1.5rem;display:block;"
        );
        h4[i].parentNode.replaceChild(h2, h4[i]);
      }
    }

    let buzzNav = document.querySelector(".single-location .buzz-nav");

    if (buzzNav) {
      buzzNav.querySelectorAll(".slick-slide");
      for (var i = 0; i < buzzNav.length; i++) {
        buzzNav[i].setAttribute("aria-hidden", "true");
      }
    }

    // Locations mobile nav (single location)
    $(".locations-mobile__toggle").on("click", function (event) {
      $(".locations-mobile__subnav").slideToggle("400");
    });

    // Get started modal
    watchAwaitSelector(function () {
      let modals = document.querySelectorAll(
        ".reveal-modal[aria-hidden=false]"
      );
      for (let modal of modals) {
        console.log(modal);
        let modalClose = modal.querySelector("[aria-label=Close]");
        console.log(modalClose);

        modal.setAttribute("tabindex", "-1");

        // Fixes body taking focus on page load
        setTimeout(() => {
          modal.focus();
        }, 150);

        trapFocus(modal);

        if (modalClose) {
          setUpClickAndEnterKey(modalClose);
        }
      }
    }, ".reveal-modal[aria-hidden=false]");
  }); // End of ready()
}

//# sourceMappingURL=global.js.map
